// extracted by mini-css-extract-plugin
module.exports = {"modalWithActions":"_1B9QEF","actions":"_1z8I5V","button":"_3T1KB_"};